module.exports = __webpack_public_path__ + "img/three1Green.ce9401c4.jpg";